import { CustomColumnGridConfig } from '../types'

const columnsConfig: CustomColumnGridConfig[] = [
  {
    width: 150,
    flex: 1,
    minWidth: 150,
    field: 'meter_id',
    headerName: 'מספר כ.מים',
    filterSpec: { kind: 'text' },
    filterable: true,
    hideable: true,
    disableAggregation: true,
  },
  {
    width: 150,
    flex: 1,
    minWidth: 150,
    field: 'water_meter_number',
    headerName: 'מספר מד',
    filterSpec: { kind: 'text' },
    filterable: true,
    hideable: true,
    disableAggregation: true,
  },
  {
    width: 150,
    flex: 1,
    minWidth: 150,
    field: 'meter_diameter',
    headerName: 'קוטר מד',
    filterSpec: { kind: 'list', options: { source: 'rows' } },
    filterable: true,
    hideable: true,
    disableAggregation: true,
  },
  {
    width: 150,
    flex: 1,
    minWidth: 150,
    field: 'address',
    headerName: 'כתובת',
    filterSpec: { kind: 'text' },
    filterable: true,
    hideable: true,
    disableAggregation: true,
  },
  {
    width: 150,
    flex: 1,
    minWidth: 150,
    field: 'measurement_zone',
    headerName: 'איזור מדידה',
    filterSpec: { kind: 'list', options: { source: 'rows' } },
    filterable: true,
    hideable: true,
    disableAggregation: true,
  },
  {
    width: 150,
    flex: 1,
    minWidth: 150,
    field: 'consumer_name',
    headerName: 'שם צרכן',
    filterSpec: { kind: 'text' },
    filterable: true,
    hideable: true,
    disableAggregation: true,
  },
  {
    width: 150,
    flex: 1,
    minWidth: 150,
    field: 'payer_number',
    headerName: 'מספר משלם',
    filterSpec: { kind: 'text' },
    filterable: true,
    hideable: true,
    disableAggregation: true,
  },

  {
    width: 150,
    flex: 1,
    minWidth: 150,
    field: 'meter_type',
    headerName: 'סוג המד',
    filterSpec: { kind: 'list', options: { source: 'rows' } },
    filterable: true,
    hideable: true,
    disableAggregation: true,
  },

  {
    width: 150,
    flex: 1,
    minWidth: 150,
    field: 'installation_date',
    headerName: 'ת.התקנה',
    filterSpec: { kind: 'date' },
    filterable: true,
    hideable: true,
    disableAggregation: true,
  },
  {
    width: 150,
    flex: 1,
    minWidth: 150,
    field: 'last_reading_date',
    headerName: 'מועד ק. אחרון',
    filterSpec: { kind: 'date' },
    filterable: true,
    hideable: true,
    disableAggregation: true,
  },
]

export default columnsConfig
